import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController, ToastController } from "@ionic/angular";
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonRow,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/angular";
import { UserHolding, UserMembership } from "src/app/account/account.model";
import { AccountService } from "src/app/account/account.service";

import { addIcons } from "ionicons";
import { openOutline } from "ionicons/icons";

@Component({
  selector: "app-upgrade-subscription",
  templateUrl: "./upgrade-subscription.component.html",
  styleUrls: ["./upgrade-subscription.component.scss"],
  standalone: true,
  imports: [
    IonButton,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonRow,
    IonSpinner,
    IonTitle,
    IonToolbar,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ModalController],
})
export class UpgradeSubscriptionComponent implements OnInit {
  // input
  @Input() errorMessage: string;

  currentMembership: UserMembership;
  limitedField: string;
  selectedUser: UserHolding;
  loading = false;
  constructor(
    private modalCtrl: ModalController,
    private accountService: AccountService,
    private toastController: ToastController,
  ) {
    addIcons({ openOutline });
    addIcons({ openOutline });
  }

  ngOnInit() {
    this.loading = true;
    if (this.errorMessage) {
      if (this.errorMessage.includes("animal")) {
        this.limitedField = "animals";
      } else if (this.errorMessage.includes("treatment")) {
        this.limitedField = "treatments";
      } else if (this.errorMessage.includes("field")) {
        this.limitedField = "fields";
      } else if (this.errorMessage.includes("movement")) {
        this.limitedField = "movements";
      }
    }
    this.accountService.getUserMembership().subscribe(res => {
      this.currentMembership = res;
      this.accountService.selectedUserHoldingGlobal.subscribe((userHolding: UserHolding) => {
        this.selectedUser = userHolding;
        this.loading = false;
      });
    });
  }

  cancel() {
    this.modalCtrl.dismiss(null, "cancel");
  }
  async redirectToSubscriptionPortal() {
    try {
      await this.accountService.openFlockFinder("payment");
      await this.modalCtrl.dismiss();
    } catch (error) {
      const toast = await this.toastController.create({
        message: error.message || "Unable to open plans. Check your connection and try again.",
        color: "danger",
        buttons: ["Dismiss"],
      });
      await toast.present();
    }
  }
}
